import { Component, OnInit } from '@angular/core';
import { PopoverController, MenuController, ModalController } from '@ionic/angular';
import { ResourceBibleService } from '../../services/resource-bible.service';
import { PtyLdService } from '../../services/pty-ld.service';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import { Router } from '@angular/router';
import { ProfileSettingsComponent } from '../profile-settings/profile-settings.component';
import { BibleService } from 'src/app/services/bible.service';
import {SeekerRequestBibleVersionComponent} from '../seeker-request-bible-version/seeker-request-bible-version.component';
import {TranslationService} from "../../services/translation.service";

@Component({
    selector: 'app-seeker-request-resources',
    templateUrl: './seeker-request-resources.component.html',
    styleUrls: ['./seeker-request-resources.component.scss'],
})
export class SeekerRequestResourcesComponent implements OnInit {


    bibles: any;
    books: any;
    chapters: any;
    verses: any;
    versesWithContent: any;
    selectedBible: any;
    selectedBook: any;
    selectedChapter: any;
    selectedVerse: any;

    allBibles: any = [];
    getMyProfile: any;

    versionSet = '';
    searchBible = false;
    isExpanded = false;
    isOldTestament = false;
    isNewTestament = true;

    searchVersesWithContent: any;


    LanguageFamily: any;
    BibleVolumes: any;
    OldBibleBooks: any;
    BibleBooks: any;
    language;
    selectedLanguages = [];
    dam_id_search;
    searchResults;
    defaultVolume;
    SearchBooks;



    constructor(
        private bibleService: ResourceBibleService,
        private _bibleService: BibleService,
        private popoverCtrl: PopoverController,
        private loaderService: PtyLdService,
        private ws: PtyWsService,
        private router: Router,
        public menuCtrl: MenuController,
        private modalCtrl: ModalController,
        private _translationService: TranslationService
    ) {
    }


    ngOnInit() {
        //  this.getBibles();

        this.getNewTestament('EN1WEBN');
        this.getOldTestament('EN1WEBO');
        this.language = 'English';

        this.getLanguageFamily();
    }

    getLanguageFamily() {
        const self = this;
        let languageFamily;
        const languagesTofilter = ['ENG', 'RUS', 'HND', 'SPN', 'AZE', 'UZB'];
        self.loaderService.showLoading(true, {}).then(() => {
            self._bibleService.volumelanguagefamily().subscribe((result) => {
                languageFamily = result;
                // this.LanguageFamily = result;
                self.loaderService.showLoading(false);
                this.LanguageFamily = [];
                languagesTofilter.map((item, index) => {
                    // tslint:disable-next-line: triple-equals
                    this.LanguageFamily.push(languageFamily.find((item) => item.language_family_code == languagesTofilter[index]));
                });
            }, (err: any) => {
                console.error('Error loading Languages', err);
                self.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });


    }

    getVolumes(event: any) {
        const self = this;
        self.loaderService.showLoading(true, {}).then(() => {
            self._bibleService.getVolumes(event.target.value).subscribe((result) => {
                this.BibleVolumes = result;
                this.defaultVolume = this.BibleVolumes[1];
                this.defaultVolume = this.BibleVolumes[1];
                self.loaderService.showLoading(false);

            }, (err: any) => {
                console.error('Error loading Languages', err);
                self.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });

        this.language = this.LanguageFamily.find((item) => item.language_family_code == event.target.value);
        this.language = this.language.language_family_english;
    }

    getBibleBooks(event: any) {
        const self = this;
        // Passing 6 charachters for pulling both testaments
        let value = event.target.value;
        value = value.split('');
        const arr = [];
        for (let x = 0; x < 6; x++) {
            arr[x] = value[x];
        }
        const result = arr.join('');
        this.dam_id_search = result;
        const oldTestament = result + 'O';
        const NewTestament = result + 'N';
        this.getOldTestament(oldTestament);
        this.getNewTestament(NewTestament);
    }

    navigateToSharedVerses() {
        this.router.navigate(['/shared-verses']);
    }

    getOldTestament(oldTestament) {
        const self = this;
        self.loaderService.showLoading(false, {}).then(() => {
            self._bibleService.getbibleBooks(oldTestament).subscribe((result) => {
                this.OldBibleBooks = result;
                self.loaderService.showLoading(false);

            }, (err: any) => {
                console.error('Error loading Languages', err);
                self.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });

    }

    getNewTestament(NewTestament) {
        const self = this;
        self.loaderService.showLoading(false, {}).then(() => {
            self._bibleService.getbibleBooks(NewTestament).subscribe((result) => {
                this.BibleBooks = result;
                self.loaderService.showLoading(false);

            }, (err: any) => {
                console.error('Error loading Languages', err);
                self.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }

    async navigateToChapter(dam_id, book_id, chapter_id) {
        const modalCtrl = await this.modalCtrl.create({
            component: SeekerRequestBibleVersionComponent,
            componentProps: {
                dam_id: dam_id,
                book_id: book_id,
                chapter_id: chapter_id,
                language: this.language,
            }
        });

        modalCtrl.onDidDismiss().then(async (item) => {
            await this.modalCtrl.dismiss(item.data);
        });

        return await modalCtrl.present();
    }

    close() {
        this.modalCtrl.dismiss();
    }

    getBibles() {
        const self = this;
        self.loaderService.showLoading(true, {}).then(() => {
            self.ws.invokeURL('get_bibles', {}).subscribe((result: any) => {
                if (result.error === 0) {
                    this.allBibles = result.bibles;
                    self.loaderService.showLoading(false);
                    this.getMyDetails();
                } else {
                    self.loaderService.showLoading(false, { message: result.message });
                }
            }, (err: any) => {
                console.error('Error loading seeker profile', err);
                self.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }

    getMyDetails() {
        const self = this;
        self.ws.invokeURL('get_my_bible_version', {}).subscribe((res: any) => {
            if (res.error === 0) {
                this.getMyProfile = res.result[0];
                if (this.getMyProfile.bible_version_uuid) {
                    this.versionSet = 'active';
                    const bible = this.allBibles.find(x => x.uuid === this.getMyProfile.bible_version_uuid);
                    this.selectedBible = bible.id;
                    this.getBooks();
                } else {
                    this.versionSet = 'inactive';
                }
            }
        });
    }

    async configureBibleVersion() {
        const modal = await this.modalCtrl.create({
            component: ProfileSettingsComponent,
            componentProps: {
                event: null
            },
            keyboardClose: false,
            backdropDismiss: false
        });

        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data != null) {

        }
    }

    getBooks() {
        this.bibleService.getBooks(this.selectedBible).subscribe((result: any) => {
            this.books = result.data;
            this.loaderService.showLoading(false);
        });
    }

    getChapters() {
        this.bibleService.getChapters(this.selectedBible, this.selectedBook).subscribe((result: any) => {
            this.chapters = result.data;
            this.loaderService.showLoading(false);
        });
    }

    async getVerses() {
        this.bibleService.getVerses(this.selectedBible, this.selectedChapter).subscribe((result: any) => {
            const data: any = [];
            result.data.forEach(element => {
                element.content = '';
                data.push(element);
            });
            this.verses = data;
            this.getVerseContent();
            this.loaderService.showLoading(false);
        });
    }

    getVerseContent() {
        this.verses.forEach(element => {
            this.bibleService.getOneVerse(this.selectedBible, element.id).subscribe((result: any) => {
                this.verses.map(function (x) {
                    if (x.id === element.id) {
                        x.content = result.data.content;
                    }
                });
            });
        });

        this.versesWithContent = this.verses;
    }

    bibleSelected(event: any) {
        this.loaderService.showLoading(true);
        this.selectedBible = event.detail.value.bible_version_uuid;
        this.getBooks();
    }

    bookSelected(event: any) {
        this.loaderService.showLoading(true);
        this.selectedBook = event.detail.value;
        this.getChapters();
    }

    chapterSelected(event: any) {
        this.loaderService.showLoading(true);
        this.selectedChapter = event.detail.value;
        this.getVerses();
    }

    verseSelected(event: any) {
        this.loaderService.showLoading(true);
        this.selectedVerse = event.detail.value;
    }

    oneVerseData(data: any) {
        this.dismiss(data.content);
    }

    async dismiss(data) {
        await this.popoverCtrl.dismiss(data);
    }

    showSearch() {
        if (this.searchBible === true) {
            this.searchBible = false;
        } else {
            this.searchBible = true;
        }
    }

    searchBibleItems(event) {
        const searchText = event.target.value;
        if (this.dam_id_search) {
            this._bibleService.search(this.dam_id_search, searchText).subscribe((result: any) => {
                if (result[1].length > 0) {
                    this.searchVersesWithContent = result[1];
                } else {
                    this.searchVersesWithContent = [{ verse_text: this._translationService.translate('NoSearchResults') }];
                }
            });
        }

        this.SearchForBooks(searchText);
    }

    SearchForBooks(searchText) {
        const searchBooks = [];
        this.OldBibleBooks.forEach(element => {
            if (searchText.toLowerCase() == element.book_name.toLowerCase()) {
                searchBooks.push(element);
            }
        });
        this.BibleBooks.forEach(element => {
            if (searchText.toLowerCase() == element.book_name.toLowerCase()) {
                searchBooks.push(element);
            }
        });
        if (searchBooks) {
            this.SearchBooks = searchBooks;
        }

    }


    async shareVerse(verse) {
        // tslint:disable-next-line: max-line-length
        verse.verse_text = `Bibble: ${verse.book_name}   Chapter:${verse.chapter_id}   Verse :${verse.verse_id}<br><br> ${verse.verse_text}`;
        await this.modalCtrl.dismiss(verse);
    }

    expandItemGeneral(i): void {
        this.SearchBooks.map((item, index) => {
            if (index == i) {
                item.isExpand = !item.isExpand;
            } else {
                item.isExpand = false;
            }
        });
    }

    expandItem(i, flag): void {
        this.isExpanded = !this.isExpanded;
        if (this.BibleBooks && flag == 'new') {
            this.BibleBooks.map((item, index) => {
                if (index == i) {
                    item.isExpanded = !item.isExpanded;
                } else { item.isExpanded = false; }
            });
        }

        if (this.OldBibleBooks && flag == 'old') {
            this.OldBibleBooks.map((item, index) => {
                if (index == i) {
                    item.isExpanded = !item.isExpanded;
                } else { item.isExpanded = false; }
            });
        }
    }
    showOldTestament(): void {
        this.isOldTestament = true;
        this.isNewTestament = false;
    }
    showNewTestament(): void {
        this.isNewTestament = !this.isNewTestament;
        this.isOldTestament = false;
    }

}
